import { AssetOptions, AssetPerson, WorkflowError } from '../../../models/employee-asset.model';
import { ASSET } from './asset.constants';

interface WorkflowIdentity {id?: string; key?: string; area?: string; operationId?: string; text?: string;}
export function workflowTrackBy(index: number, item: string | WorkflowIdentity): string | number {
  if (typeof item === STRING_TYPE) { return <string>item; }
  const record = <WorkflowIdentity>item;
  return record.id || record.key || record.area || record.operationId || record.text || index;
}
const STRING_TYPE = 'string';

export function assetOwners(options: AssetOptions, asset: {kind: string; category?: string}): AssetPerson[] {
  const required = asset.kind === ASSET.service || asset.kind === ASSET.serialized && asset.category === ASSET.itEquipment
    ? ASSET.serviceOwner : ASSET.assetCustodian;
  return options ? (options.owners || []).filter(person =>
    (person.functions || []).indexOf(required) >= ASSET.zero) : [];
}

export function assetOperationId(): string {
  return ASSET.operationPrefix + Date.now().toString(ASSET.randomRadix) + ASSET.dash +
    Math.random().toString(ASSET.randomRadix).slice(ASSET.randomOffset);
}

export function assetToday(): string {
  const date = new Date();
  const month = String(date.getMonth() + ASSET.one);
  const day = String(date.getDate());
  const pad = (value: string) => value.length < ASSET.randomOffset ? String(ASSET.zero) + value : value;
  return date.getFullYear() + ASSET.dash + pad(month) + ASSET.dash + pad(day);
}

export function assetErrorKey(error: WorkflowError, mutation: boolean): string {
  if (error && (error.status === ASSET.forbidden || error.status === ASSET.unauthorized)) {
    return ASSET.deniedKey;
  }
  if (error && error.status === ASSET.conflict) { return ASSET.conflictKey; }
  if (error && error.status === ASSET.invalid) { return ASSET.validationKey; }
  return mutation ? ASSET.unknownKey : ASSET.failureKey;
}

export function safeServiceUrl(value: string): string {
  return value && /^https?:\/\/[^\s]+$/i.test(value.trim()) ? value.trim() : ASSET.empty;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/employee-assets/asset.helpers.ts